import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const initialState = {
  cartArr: [],
  servicesOutsideTheTemple: [],
  rentArr: [],
  cateringArr: [],
  cafeteriaArr: [],
  personalServiceCartArr: [],
  events: [],
  popupTime: ''
};

export const counterSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    updateCart: (state, action) => {
      const { _id, quantity, amount, selectedDate } = action.payload;
      const index = state.cartArr.findIndex((item) => {
        return item._id === _id && item?.selectedDate === selectedDate;
      });

      if (index !== -1) {
        state.cartArr[index] = {
          ...state.cartArr[index],
          quantity: quantity || 1,
          amount,
          selectedDate: selectedDate
        };
      }
    },

    addToCart: (state, action) => {
      const { selectedDate } = action.payload;

      if (selectedDate) {
        const newItem = {
          ...action.payload,
          selectedDate: selectedDate
        };
        state.cartArr.push(newItem);
      }
    },

    clearCart: (state) => {
      state.cartArr = [];
    },

    removeFromCart: (state, action) => {
      const { _id, selectedDate } = action.payload;
      const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');

      state.cartArr = state.cartArr.filter(
        (item) => !(item._id === _id && dayjs(item.selectedDate).format('YYYY-MM-DD') === formattedDate)
      );
    },

    serviceOutsideUpdateCart: (state, action) => {
      const { _id, quantity, amount, selectedDate } = action.payload;
      const index = state.servicesOutsideTheTemple.findIndex((item) => {
        return item._id === _id && item?.selectedDate === selectedDate;
      });

      if (index !== -1) {
        state.servicesOutsideTheTemple[index] = {
          ...state.servicesOutsideTheTemple[index],
          ...action.payload,
          quantity: quantity || 1,
          amount,
          selectedDate: selectedDate
        };
      }
    },

    serviceOutsideAddToCart: (state, action) => {
      const { selectedDate } = action.payload;

      if (selectedDate) {
        const newItem = {
          ...action.payload,
          selectedDate: selectedDate
        };
        state.servicesOutsideTheTemple.push(newItem);
      }
    },

    serviceOutsideClearCart: (state) => {
      state.servicesOutsideTheTemple = [];
    },

    serviceOutsideRemoveFromCart: (state, action) => {
      const { _id, selectedDate } = action.payload;
      const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');

      state.servicesOutsideTheTemple = state.servicesOutsideTheTemple.filter(
        (item) => !(item._id === _id && dayjs(item.selectedDate).format('YYYY-MM-DD') === formattedDate)
      );
    },

    updateRentCart: (state, action) => {
      if (!action.payload) {
        state.rentArr = [];
      } else {
        const { _id } = action.payload;
        const existingItemIndex = state.rentArr.findIndex((item) => item._id === _id);

        if (existingItemIndex !== -1) {
          state.rentArr[existingItemIndex] = action.payload;
        } else {
          state.rentArr.push(action.payload);
        }
      }
    },

    removeFromRentCart: (state, action) => {
      const itemIdToRemove = action.payload;
      state.rentArr = state.rentArr.filter((item) => item._id !== itemIdToRemove);
    },

    clearRentCart: (state) => {
      state.rentArr = [];
    },

    cateringAddToCart: (state, action) => {
      state.cateringArr.push(action.payload);
    },

    cateringAddToCart: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.cateringArr.push(...action.payload);
      } else {
        state.cateringArr.push(action.payload);
      }
    },

    cateringUpdateCart: (state, action) => {
      const { _id, quantity, amount, size, sizeportion, quantity_type } = action.payload;

      const index = state.cateringArr.findIndex((item) => {
        return quantity_type === 'variable '
          ? item._id === _id
          : item._id === _id && item?.size === size && item?.sizeportion === sizeportion;
      });

      if (index !== -1) {
        state.cateringArr[index] = {
          ...state.cateringArr[index],
          quantity: quantity || 1,
          amount,
          size,
          sizeportion
        };
      }
    },

    cateringClearCart: (state) => {
      state.cateringArr = [];
    },

    cateringRemoveFromCart: (state, action) => {
      const { _id, sizeportion, size } = action.payload;

      state.cateringArr = state.cateringArr.filter(
        (item) => !(item._id === _id && item?.sizeportion === sizeportion && item?.size === size)
      );
    },

    cafeteriaAddToCart: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.cafeteriaArr.push(...action.payload);
      } else {
        state.cafeteriaArr.push(action.payload);
      }
    },

    cafeteriaUpdateCart: (state, action) => {
      const { quantity, amount, togo, _id } = action.payload;
      const index = state.cafeteriaArr.findIndex((item) => {
        return item._id === _id && item?.togo === togo;
      });

      if (index !== -1) {
        state.cafeteriaArr[index] = {
          ...state.cafeteriaArr[index],
          quantity: quantity || 1,
          amount,
          togo: togo
        };
      }
    },

    cafeteriaClearCart: (state) => {
      state.cafeteriaArr = [];
    },

    cafeteriaRemoveFromCart: (state, action) => {
      const { _id, togo } = action.payload;

      state.cafeteriaArr = state.cafeteriaArr.filter((item) => !(item?._id === _id && item?.togo === togo));
    },

    personalServiceUpdateCart: (state, action) => {
      const { _id, quantity, amount, selectedDate } = action.payload;
      const index = state?.personalServiceCartArr?.findIndex((item) => {
        return item._id === _id && item?.selectedDate === selectedDate;
      });

      if (index !== -1) {
        state.personalServiceCartArr[index] = {
          ...state.personalServiceCartArr[index],
          ...action.payload,
          quantity: quantity || 1,
          amount,
          selectedDate: selectedDate
        };
      }
    },

    personalServiceAddToCart: (state, action) => {
      const { selectedDate } = action.payload;

      if (selectedDate) {
        const newItem = {
          ...action.payload,
          selectedDate: selectedDate
        };
        state.personalServiceCartArr.push(newItem);
      }
    },

    personalServiceClearCart: (state) => {
      state.personalServiceCartArr = [];
    },

    personalServiceRemoveFromCart: (state, action) => {
      const { _id, selectedDate } = action.payload;
      const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');

      state.personalServiceCartArr = state.personalServiceCartArr.filter(
        (item) => !(item._id === _id && dayjs(item.selectedDate).format('YYYY-MM-DD') === formattedDate)
      );
    },

    addEventData: (state, action) => {
      const newItem = {
        ...action.payload,
        type: 9
      };
      state.events.push(newItem);
    },

    removeEventData: (state, action) => {
      state.events = [];
    }
  }
});

export const {
  addToCart,
  updateCart,
  updateRentCart,
  clearCart,
  removeFromCart,
  serviceOutsideUpdateCart,
  serviceOutsideAddToCart,
  serviceOutsideClearCart,
  serviceOutsideRemoveFromCart,
  updatePrasadamCart,
  removeFromPrasadamCart,
  removeFromRentCart,
  cateringAddToCart,
  cateringClearCart,
  cateringRemoveFromCart,
  cateringUpdateCart,
  clearRentCart,
  cafeteriaAddToCart,
  cafeteriaClearCart,
  cafeteriaRemoveFromCart,
  cafeteriaUpdateCart,
  personalServiceAddToCart,
  personalServiceClearCart,
  personalServiceRemoveFromCart,
  personalServiceUpdateCart,
  addEventData,
  removeEventData
} = counterSlice.actions;

export default counterSlice.reducer;
